import React from 'react';
import { styled } from '@compiled/react';
import { layers } from '@jira/platform__ui-layers';
import Blanket from '@atlaskit/blanket';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const LoadingScreen = (): React.JSX.Element => (
	<Wrapper>
		<Blanket isTinted />
		<SpinnerWrapper>
			<Spinner size="medium" />
		</SpinnerWrapper>
	</Wrapper>
);

export default LoadingScreen;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const SpinnerWrapper = styled.div({
	position: 'fixed',

	left: '50%',
	marginTop: token('space.800'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Wrapper = styled.div({
	height: '100%',
	left: 0,
	position: 'fixed',
	top: 0,
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layers.blanket,
});
